import { pathOr } from 'ramda';
import { IApplicationState } from '../../../types/redux';

export const getIsFilterUpcomingSaleEnabled = (state: IApplicationState): boolean => {
  return pathOr(false, ['jsonQuery', 'is_upcoming_sale', 'value'], state.location) || false;
};
